// ── Types ────────────────────────────────────────────────────────────────────

export interface Location {
  id: string
  name: string
  address: string
  gbpConnected?: boolean
  rating?: number
  reviewCount?: number
}

export interface LocationSwitcherProps {
  locations: Location[]
  activeLocationId: string
  onLocationChange: (locationId: string) => void
}

/**
 * Multi-location dropdown for the header.
 *
 * Desktop: inline dropdown with location pin icon, separated by a border-left.
 * Mobile: compact select element.
 *
 * Only renders when there are 2+ locations.
 */
export function LocationSwitcher({
  locations,
  activeLocationId,
  onLocationChange,
}: LocationSwitcherProps) {
  if (!locations || locations.length <= 1) return null

  return (
    <>
      {/* Desktop variant */}
      <div className="hidden sm:flex items-center gap-1.5 border-l pl-3" style={{ borderColor: 'var(--border)' }}>
        <svg className="w-3.5 h-3.5 text-blue-500 flex-shrink-0" fill="currentColor" viewBox="0 0 384 512">
          <path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 0 1 0-128z" />
        </svg>
        <select
          value={activeLocationId}
          onChange={(e) => onLocationChange(e.target.value)}
          className="input-select-sm font-medium"
        >
          {locations.map((loc) => (
            <option key={loc.id} value={loc.id}>
              {loc.name}
            </option>
          ))}
        </select>
      </div>

      {/* Mobile variant */}
      <div className="sm:hidden">
        <select
          value={activeLocationId}
          onChange={(e) => onLocationChange(e.target.value)}
          className="input-select-sm font-medium"
        >
          {locations.map((loc) => (
            <option key={loc.id} value={loc.id}>
              {loc.name}
            </option>
          ))}
        </select>
      </div>
    </>
  )
}
